import { render, staticRenderFns } from "./ForumsList.vue?vue&type=template&id=1c647260&scoped=true&"
import script from "./ForumsList.vue?vue&type=script&lang=js&"
export * from "./ForumsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c647260",
  null
  
)

export default component.exports